module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dn-dialog', {
    ref: "dialog",
    attrs: {
      "content-class": "dn-db-manager-dialog dn-db-manager-error-dialog"
    }
  }, [_c('h3', {
    staticClass: "my-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [(_vm.$slots.header) ? _vm._t("header") : _c('div', [_vm._v("エラーが発生しました")])], 2), _vm._v(" "), _c('div', {
    staticClass: "my-message"
  }, [_vm._t("message")], 2), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "my-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    staticClass: "my-btn--apply",
    attrs: {
      "block-sp": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$refs.dialog.hide($event)
      }
    }
  }, [_vm._v("閉じる")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65a90bed","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/manager/DbManager/dialogs/ErrorDialogBase.vue
// module id = 442
// module chunks = 1